import 'css-chunksrc/client/pages/zonesPage/wbsPage/sort/styles.scss';export default {
  "sort": "_sort_mkf7j_1",
  "label": "_label_mkf7j_9",
  "input": "_input_mkf7j_15",
  "placeholder": "_placeholder_mkf7j_31",
  "icon": "_icon_mkf7j_39",
  "listRoot": "_listRoot_mkf7j_47",
  "list": "_list_mkf7j_47",
  "item": "_item_mkf7j_63",
  "option": "_option_mkf7j_76",
  "selected": "_selected_mkf7j_83",
  "opened": "_opened_mkf7j_96"
};